export const activityLogs = [
  {
    id: 1,
    userId: 1,
    userName: 'John Doe',
    userEmail: 'john@example.com',
    action: 'alert_created',
    actionLabel: 'Created price alert',
    productId: 1,
    productName: 'iPad Pro M2',
    details: { targetPrice: 999, threshold: 10 },
    timestamp: '2024-06-15T14:32:00Z',
    ipAddress: '192.168.1.100',
    userAgent: 'Chrome/125.0 (Windows)',
  },
  {
    id: 2,
    userId: 2,
    userName: 'Sarah Smith',
    userEmail: 'sarah@example.com',
    action: 'alert_triggered',
    actionLabel: 'Alert triggered',
    productId: 5,
    productName: 'iPhone 15 Pro',
    details: { targetPrice: 899, triggeredPrice: 879, savings: 120 },
    timestamp: '2024-06-15T13:45:00Z',
    ipAddress: '10.0.0.55',
    userAgent: 'Safari/17.0 (macOS)',
  },
  {
    id: 3,
    userId: 1,
    userName: 'John Doe',
    userEmail: 'john@example.com',
    action: 'alert_deleted',
    actionLabel: 'Deleted price alert',
    productId: 3,
    productName: 'Sony A7 IV Camera',
    details: { reason: 'User cancelled' },
    timestamp: '2024-06-15T12:20:00Z',
    ipAddress: '192.168.1.100',
    userAgent: 'Chrome/125.0 (Windows)',
  },
  {
    id: 4,
    userId: 3,
    userName: 'Mike Johnson',
    userEmail: 'mike@example.com',
    action: 'alert_modified',
    actionLabel: 'Modified price alert',
    productId: 7,
    productName: 'MacBook Pro M3 Pro',
    details: { oldTargetPrice: 1899, newTargetPrice: 1799 },
    timestamp: '2024-06-15T11:15:00Z',
    ipAddress: '172.16.0.22',
    userAgent: 'Firefox/126.0 (Linux)',
  },
  {
    id: 5,
    userId: 4,
    userName: 'Emily Brown',
    userEmail: 'emily@example.com',
    action: 'email_sent',
    actionLabel: 'Email notification sent',
    productId: 2,
    productName: 'Dyson Supersonic',
    details: { emailType: 'price_drop', emailSubject: 'Price Drop Alert!' },
    timestamp: '2024-06-15T10:30:00Z',
    ipAddress: '192.168.2.45',
    userAgent: 'Chrome/125.0 (iOS)',
  },
  {
    id: 6,
    userId: 5,
    userName: 'David Wilson',
    userEmail: 'david@example.com',
    action: 'alert_created',
    actionLabel: 'Created price alert',
    productId: 6,
    productName: 'LG 27" 4K Monitor',
    details: { targetPrice: 699, threshold: 15 },
    timestamp: '2024-06-15T09:45:00Z',
    ipAddress: '10.10.10.10',
    userAgent: 'Edge/125.0 (Windows)',
  },
  {
    id: 7,
    userId: 2,
    userName: 'Sarah Smith',
    userEmail: 'sarah@example.com',
    action: 'product_viewed',
    actionLabel: 'Viewed product from alert',
    productId: 5,
    productName: 'iPhone 15 Pro',
    details: { source: 'email_notification' },
    timestamp: '2024-06-15T09:00:00Z',
    ipAddress: '10.0.0.55',
    userAgent: 'Safari/17.0 (macOS)',
  },
  {
    id: 8,
    userId: 1,
    userName: 'John Doe',
    userEmail: 'john@example.com',
    action: 'alert_paused',
    actionLabel: 'Paused price alert',
    productId: 4,
    productName: 'Vitamix Blender',
    details: { pauseDuration: '7 days' },
    timestamp: '2024-06-14T16:20:00Z',
    ipAddress: '192.168.1.100',
    userAgent: 'Chrome/125.0 (Windows)',
  },
  {
    id: 9,
    userId: 3,
    userName: 'Mike Johnson',
    userEmail: 'mike@example.com',
    action: 'email_clicked',
    actionLabel: 'Clicked email link',
    productId: 8,
    productName: 'ASUS WiFi 7 Router',
    details: { linkType: 'shop_now', retailer: 'Amazon' },
    timestamp: '2024-06-14T15:10:00Z',
    ipAddress: '172.16.0.22',
    userAgent: 'Firefox/126.0 (Linux)',
  },
  {
    id: 10,
    userId: 4,
    userName: 'Emily Brown',
    userEmail: 'emily@example.com',
    action: 'alert_resumed',
    actionLabel: 'Resumed price alert',
    productId: 2,
    productName: 'Dyson Supersonic',
    details: {},
    timestamp: '2024-06-14T14:00:00Z',
    ipAddress: '192.168.2.45',
    userAgent: 'Chrome/125.0 (iOS)',
  },
  {
    id: 11,
    userId: 5,
    userName: 'David Wilson',
    userEmail: 'david@example.com',
    action: 'bulk_alerts_created',
    actionLabel: 'Created multiple alerts',
    productId: null,
    productName: null,
    details: {
      count: 5,
      products: [
        'iPad Pro M2',
        'iPhone 15 Pro',
        'MacBook Pro M3 Pro',
        'Sony A7 IV Camera',
        'LG 27" 4K Monitor',
      ],
    },
    timestamp: '2024-06-14T12:30:00Z',
    ipAddress: '10.10.10.10',
    userAgent: 'Edge/125.0 (Windows)',
  },
  {
    id: 12,
    userId: 2,
    userName: 'Sarah Smith',
    userEmail: 'sarah@example.com',
    action: 'unsubscribed',
    actionLabel: 'Unsubscribed from alerts',
    productId: 1,
    productName: 'iPad Pro M2',
    details: { reason: 'Too many emails' },
    timestamp: '2024-06-14T11:00:00Z',
    ipAddress: '10.0.0.55',
    userAgent: 'Safari/17.0 (macOS)',
  },
];

export const actionTypes = [
  { id: 'alert_created', label: 'Alert Created', icon: 'ri-add-circle-line', color: 'bg-green-100 text-green-600' },
  { id: 'alert_triggered', label: 'Alert Triggered', icon: 'ri-notification-3-line', color: 'bg-amber-100 text-amber-600' },
  { id: 'alert_deleted', label: 'Alert Deleted', icon: 'ri-delete-bin-line', color: 'bg-red-100 text-red-600' },
  { id: 'alert_modified', label: 'Alert Modified', icon: 'ri-edit-line', color: 'bg-teal-100 text-teal-600' },
  { id: 'alert_paused', label: 'Alert Paused', icon: 'ri-pause-circle-line', color: 'bg-gray-100 text-gray-600' },
  { id: 'alert_resumed', label: 'Alert Resumed', icon: 'ri-play-circle-line', color: 'bg-emerald-100 text-emerald-600' },
  { id: 'email_sent', label: 'Email Sent', icon: 'ri-mail-send-line', color: 'bg-cyan-100 text-cyan-600' },
  { id: 'email_clicked', label: 'Email Clicked', icon: 'ri-cursor-line', color: 'bg-indigo-100 text-indigo-600' },
  { id: 'product_viewed', label: 'Product Viewed', icon: 'ri-eye-line', color: 'bg-pink-100 text-pink-600' },
  { id: 'bulk_alerts_created', label: 'Bulk Alerts', icon: 'ri-stack-line', color: 'bg-orange-100 text-orange-600' },
  { id: 'unsubscribed', label: 'Unsubscribed', icon: 'ri-user-unfollow-line', color: 'bg-rose-100 text-rose-600' },
];
